module.exports = __webpack_public_path__ + "img/qrCode2.519ee4d8.png";